import { render } from "./HidingAd.vue?vue&type=template&id=10722df4&scoped=true"
import script from "./HidingAd.vue?vue&type=script&lang=js"
export * from "./HidingAd.vue?vue&type=script&lang=js"

import "./HidingAd.vue?vue&type=style&index=0&id=10722df4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10722df4"]])

export default __exports__